export default __webpack_public_path__ + "static/media/gambrel.24c8aace.png";